import { render, staticRenderFns } from "./MsgElementText.vue?vue&type=template&id=4e33d8d8&scoped=true"
import script from "./MsgElementText.vue?vue&type=script&lang=js"
export * from "./MsgElementText.vue?vue&type=script&lang=js"
import style0 from "./MsgElementText.vue?vue&type=style&index=0&id=4e33d8d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e33d8d8",
  null
  
)

export default component.exports